export const SupportServiceImplFactory = ({
  supportRepository,
}: {
  supportRepository: ISupportRepository;
}) => {
  const addReportAProblem: IAddReportAProblem = async ({
    clinicId,
    name,
    reportType,
    subject,
    details,
    photos,
  }) => {
    try {
      const response = await supportRepository.addReportAProblem({
        clinic_id: clinicId.toString(),
        name,
        problem_category: reportType,
        subject,
        description: details,
        images: photos.map((item) => ({
          name: item.name,
          base64_enc_file: item.base64,
        })),
      });
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const submitFeedback: ISubmitFeedback = async (payload: {
    name: string;
    message: string;
  }) => {
    const { name, message } = payload;
    const text = `${name},
    ${message}`;
    const response = await supportRepository.submitFeedback({
      text,
    });
    const { error, data } = response;
    if (error) {
      return {
        success: false,
        data,
      };
    }
    return {
      success: true,
      data,
    };
  };

  const submitRatingService: ISubmitRatingService = async (payload) => {
    try {
      const response = await supportRepository.submitRatingAPI(payload);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  return { addReportAProblem, submitFeedback, submitRatingService };
};
